import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export interface PredefinedMessageDialogData {
    mode: 'add' | 'edit';
    langs: string[];
    message?: { [lang: string]: string };
}

@Component({
    selector: 'app-predefined-message-dialog',
    templateUrl: './predefined-message-dialog.component.html',
    styleUrls: ['./predefined-message-dialog.component.scss'],
})
export class PredefinedMessageDialogComponent {
    form: FormGroup;
    langs: string[];
    mode: 'add' | 'edit';

    constructor(
        public dialogRef: MatDialogRef<PredefinedMessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: PredefinedMessageDialogData,
        private translate: TranslateService,
    ) {
        this.mode = data.mode;
        this.langs = data.langs;
        this.form = this.buildForm();
    }

    private buildForm(): FormGroup {
        const group: { [key: string]: FormControl } = {};
        for (const lang of this.langs) {
            group[lang] = new FormControl(this.data.message?.[lang] || '', [Validators.required]);
        }
        return new FormGroup(group);
    }

    getControl(lang: string): FormControl {
        return this.form.get(lang) as FormControl;
    }

    submit(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        } else {
            this.form.markAllAsTouched();
        }
    }

    cancel(): void {
        this.dialogRef.close(null);
    }
}
